<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <div v-if="clientData">
      <div v-if="clientData.trustworthy == true && ($store.state.roles.Backoffice_member || $store.state.roles.Backoffice_supervisor)" class="row">
        <div class="col-12 mt-2">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="checkWhiteList" v-model.trim="checkWhiteList"
              :checked="clientData.trustworthy == true" disabled />
            <label class="custom-control-label labelCheck pb-4" for="checkWhiteList" v-if="!$store.state.roles.Backoffice_member_empresas">Cliente
              añadido a la White
              List</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal" v-if="!$store.state.roles.Backoffice_member_empresas">Nombre</div>
          <div class="generalTitleItemModal" v-if="$store.state.roles.Backoffice_member_empresas">Nombre de la compañía</div>
          <div>{{ clientData.name }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Apellido1</div>
          <div>{{ clientData.surnames }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Teléfono</div>
          <div>{{ clientData.telephone || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Móvil</div>
          <div>{{ clientData.mobile || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Número de documento</div>
          <div>{{ clientData.legalIdentifier }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Tipo de doc</div>
          <div>DNI</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">CIF</div>
          <div>{{ clientData.legalIdentifier }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">CNAE</div>
          <div>{{ clientData.cname || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Nº Empleados</div>
          <div>{{ clientData.numberEmployees || '-' }}</div>
        </div>
        <!--<div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Fecha de constitución</div>
          <div>{{ '12/02/1985' || '-' }}</div>
        </div>-->
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Fecha de nacimiento</div>
          <div>{{ $dateBackToFront(clientData.birthdate) }}</div>
        </div>
        <!--<div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Idioma preferido</div>
        <div>Español</div>
      </div>-->
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Email</div>
          <div>{{ clientData.email || '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Antigüedad en Rentik</div>
          <div>{{ seniorityText }}</div>
        </div>
      </div>
      <div v-if="clientData.scoringCustomer && !$store.state.roles.Backoffice_member_empresas" class="row mt-1">
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Scoring</div>
          <div>{{ clientData.scoringCustomer ? clientData.scoringCustomer.defaultProbability : '-' }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha scoring</div>
          <div>{{ clientData.scoringCustomer ? $dateBackToFront(clientData.scoringCustomer.createdDate) : '-' }}</div>
        </div>
      </div>
    </div>
    <div v-if="clientData.deliveryAddress">
      <div class="mt-5" v-if="!$store.state.roles.Backoffice_member_empresas">
        DIRECCIÓN
        <hr>
      </div>
      <div class="mt-5" v-if="$store.state.roles.Backoffice_member_empresas">
        DIRECCIÓN DE LA COMPAÑÍA
        <hr>
      </div>
      <div class="row">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Dirección</div>
          <div>{{ clientData.deliveryAddress.street }} </div>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Número</div>
          <div>{{ clientData.deliveryAddress.number }}</div>
        </div>
        <!--<div class="col-3 mb-3">
        <div class="generalTitleItemModal">Piso</div>
        <div>8</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Puerta</div>
        <div>B</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Escalera</div>
        <div>-</div>
      </div>-->
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Localidad</div>
          <div>{{ clientData.deliveryAddress.city }}</div>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Provincia</div>
          <div>{{ clientData.deliveryAddress.province }}</div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">País</div>
          <div>España</div>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Código postal</div>
          <div>{{ clientData.deliveryAddress.postalCode }}</div>
        </div>
      </div>
    </div>
    <div v-if="clientData.billingAddress">
      <div class="mt-5" v-if="!$store.state.roles.Backoffice_member_empresas">
        DIRECCIÓN DE FACTURACIÓN
        <hr>
      </div>
      <div class="mt-5" v-if="$store.state.roles.Backoffice_member_empresas">
        DIRECCIÓN DE FACTURACIÓN DE LA COMPAÑÍA
        <hr>
      </div>
      <div class="row">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Dirección</div>
          <div>{{ clientData.billingAddress.street }} </div>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Número</div>
          <div>{{ clientData.billingAddress.number }}</div>
        </div>
        <!--<div class="col-3 mb-3">
        <div class="generalTitleItemModal">Piso</div>
        <div>8</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Puerta</div>
        <div>B</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Escalera</div>
        <div>-</div>
      </div>-->
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Localidad</div>
          <div>{{ clientData.billingAddress.city }}</div>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Provincia</div>
          <div>{{ clientData.billingAddress.province }}</div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">País</div>
          <div>España</div>
        </div>
        <div class="col-3 mb-3">
          <div class="generalTitleItemModal">Código postal</div>
          <div>{{ clientData.billingAddress.postalCode }}</div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.roles.Backoffice_member_empresas">
      <template v-for="(auths, index) in clientData.companyContact" v-bind:key="index">
        <div class="mt-5">
          AUTORIZADO {{ index + 1 }}
          <hr>
        </div>
        <div class="row">
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Nombre</div>
            <div>{{ auths.name }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">DNI</div>
            <div>{{ auths.legalIdentifier || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Teléfono</div>
            <div>{{ auths.mobile }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Email</div>
            <div>{{ auths.email }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Poderes</div>
            <div v-if="auths.powers">Si</div>
            <div v-else>No</div>
          </div>
        </div>
      </template>
    </div>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
export default {
  name: 'ClientDataDetail',
  props: [
    'id',
    'modalTitle',
    'class',
    'clientInfo',
  ],
  data() {
    return {
      classes: this.class,
      clientData: '',
    };
  },
  computed: {
    seniorityText() {
      const seniority = this.clientData && this.clientData.seniority;
      if (!seniority || !seniority.startDate) return '-';
      const months = seniority.months || 0;
      return `${months} ${months === 1 ? 'mes' : 'meses'} (desde ${this.$dateBackToFront(seniority.startDate)})`;
    }
  },
  // watch: {
  //   clientInfo() {
  //     this.loadClientData();
  //   }
  // },
  updated() {
    this.loadClientData();
  },
  components: {
    Modal,
  },
  methods: {
    loadClientData() {
      if (this.clientInfo !== undefined) {
        this.clientData = this.clientInfo;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
